import { PatientInsurance } from "pwapi";

import { shallowLeftDiff } from "shared/utils/formUtils";

export const initialValuesForPatientInsurance = (
  insurance: PatientInsurance,
  hasPrimaryInsurance?: boolean
): PatientInsurance => {
  return {
    ...insurance,
    primary_provider: insurance?.id
      ? insurance.primary_provider
      : !hasPrimaryInsurance,
    relationship_to_patient:
      insurance?.relationship_to_patient === "SEL"
        ? "SELF"
        : insurance.relationship_to_patient,
  };
};

export const submissionFieldsForPatientInsurance = (
  insurance: PatientInsurance,
  isManual: boolean,
  values?: Partial<PatientInsurance>
) => {
  if (!values) values = initialValuesForPatientInsurance(insurance);

  const userInfo =
    values.relationship_to_patient === "SELF"
      ? { relationship_to_patient: "SELF" }
      : {
          relationship_to_patient: values.relationship_to_patient || null,
          insured_first_name: values.insured_first_name || null,
          insured_last_name: values.insured_last_name || null,
          insured_date_of_birth: values.insured_date_of_birth || null,
        };

  const insuranceCompanyDetails = isManual
    ? {
        insurance_company_name: values.insurance_company_name || null,
        insurance_company_state: values.insurance_company_state || null,
        insurance_company_city: values.insurance_company_city || null,
        insurance_company_zipcode: values.insurance_company_zipcode || null,
        insurance_company_address: values.insurance_company_address || null,
        insurance_company_address2: values.insurance_company_address2 || null,
        plan: undefined,
      }
    : {
        plan: values.plan?.id ? { id: values.plan.id } : null,
      };

  return {
    ...userInfo,
    ...insuranceCompanyDetails,
    primary_provider: values.primary_provider || false,
    has_abn: values.has_abn || false,
    preapproval_id: values.preapproval_id || null,
    policy_number: values.policy_number || null,
    group_employer_id: values.group_employer_id || null,
  };
};

export const shallowPatientInsuranceComparison = (
  insurance: PatientInsurance,
  values: Partial<PatientInsurance>,
  isManual: boolean
) => {
  const oldValues = submissionFieldsForPatientInsurance(insurance, isManual);
  const newValues = submissionFieldsForPatientInsurance(
    insurance,
    isManual,
    values
  );

  return shallowLeftDiff<
    ReturnType<typeof submissionFieldsForPatientInsurance>
  >(oldValues, newValues);
};
